export const url = {
  validate: value => {
    return new RegExp(
      'https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_\\+.~#?&/=]*)',
      'i'
    ).test(value);
  }
};
